import { render } from "./OurPartner.vue?vue&type=template&id=6d1f6bfe"
import script from "./OurPartner.vue?vue&type=script&lang=js"
export * from "./OurPartner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__